import { ReactComponent as EditRoomInformationSvg } from "../../assets/images/svgs/editRoomInformation.svg";

const EditRoomInformationIcon = ({ className = "", ...props }) => {
  return (
    <EditRoomInformationSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default EditRoomInformationIcon;
